import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { customerInformationFieldNames } from './customerInformationFieldNames';

export const getCustomerInformationTotals = (formFields, orderData) => {
  const customerInformationTotals = getTotalsForSetOfTotals(
    customerInformationFieldNames,
    formFields,
    orderData
  );
  return customerInformationTotals;
};

export const getCustomerInformationPriceSelections = formFields => {
  const selectionsList = priceSelectionList(
    customerInformationFieldNames,
    formFields
  );
  return selectionsList;
};
